import { render } from "./IssueItem.vue?vue&type=template&id=b90553b2&scoped=true"
import script from "./IssueItem.vue?vue&type=script&lang=js"
export * from "./IssueItem.vue?vue&type=script&lang=js"

import "./IssueItem.vue?vue&type=style&index=0&id=b90553b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b90553b2"

export default script